import config from "../config.json";

/*App Constants*/
export const AppConstants = {
  DebounceDelay: 500,
  DdlSearchMinLength: 2,
};
/*App Constants*/

/*Notification Types*/
export const NotificationTypes = {
  Notification: 1,
  Message: 2,
  Payment: 3,
};
/*Notification Types*/

export const AppDetails = {
  address: "113 State Hwy 121 Coppell, TX 75019",
  phone: "+1 (972) 891-9369",
  email: "info@assetswatch.com",
  devicetypeid: 3, //web
};

/*pdf Settings*/
export const html2PdfSettings = {
  margin: [5, 10, 30, 10],
  //image: { type: "jpeg", quality: 0.98 },
  enableLinks: true,
  html2canvas: {
    backgroundColor: null,
    scale: 3,
    dpi: 300,
    letterRendering: true,
    allowTaint: true,
    useCORS: true,
    logging: false,
  },
  jsPDF: {
    unit: "mm",
    format: "a4",
    orientation: "portrait",
    compress: true,
    debug: false,
  },
  pagebreak: { mode: ["avoid-all", "css", "legacy"] },
};

export const pdfHFWMSettings = {
  wmWidth: 100,
  wmHeight: 100,
  wmOpacity: { opacity: 0.4 },
  wmyOffSet: 10,
  fLineColor: { r: 113, g: 184, b: 95 },
  fLinex1OffSet: 8,
  fLiney1OffSet: 20,
  fTextyOffSet: 15,
  fFontSize: 9,
  fFontFamily: ["helvetica", "italic"],
  fFontColor: { r: 66, g: 66, b: 68 },
  fCenter: { align: "center" },
  fRight: { align: "right" },
  fPixOffSet: 15,
  fPiyOffSet: 8,
  scaleFactor: 2,
  pageHalf: 2,
  hTextyOffSet: 10,
};
/*pdf Settings*/

/*Local storage keys*/
export const LSApiTokenKey = "apitoken";
export const LSDeviceIdKey = "deviceid";
export const LSTokenKey = "token";
export const LSExpiryKey = "expires";
export const LSRegFormData = "rfd";
/*Local storage keys*/

/*Session storage keys*/
export const SessionStorageKeys = {
  EditAssetId: "eassetid",
  ViewAssetId: "vassetid",
  ObjAssetfilters: "oasf",
  OwnerTenantConnectionTab: "otcontab",
  TenantCheckoutPaymentId: "tcpmid",
  EditProfileId: "epid",
  SendAgreementTemplateId: "sagtid",
  ViewAgreementTemplateId: "vagtid",
  ObjSendAgreement: "osag",
  ViewEditDocumentId: "vedid",
  ManageAccessDocumentId: "madid",
  ViewEditAgreementfolderId: "veagfid",
  ViewEditAgreementId: "veaid",
  ViewEditDocfolderId: "vedfid",
  ViewSharedDocfolderId: "vsdfid",
  ViewSharedDocRootfolderId: "vsdrfid",
  ViewSharedDocRootfolder: "vsdrf",
  ViewSharedDocUsersSharedId: "vsdusid",
  ManageAccessAgreementId: "maaid",
  // Stores deeplinks while private file access sends the user through login/setup.
  PendingDeepLinkUrl: "pdlu",
  ViewPaymentSubAccountId: "vpsaid",
  SelectedPaymentChannelId: "spcid",
  // One-shot flag: set by Accounts before navigating to Create Account so the
  // pending-account check isn't repeated there. Cleared on first read, so a
  // direct load/reload of Create Account still runs the check.
  PaymentPendingCheckDone: "ppcd",
  ViewInvoiceItemId: "viiid",
  ViewInvoiceId: "viid",
  EditInvoiceId: "eiid",
  PreviewInvoiceId: "pviid",
  // Set alongside PreviewInvoiceId when previewing a recurring invoice. The
  // preview page reads it and, on confirm, calls CreateRecurringInvoice
  // (with these fields) + deletes the temp preview invoice.
  PreviewRecurringData: "pvrecd",
  // Snapshot of CreateInvoice user-input state; saved before navigating to
  // Preview so cancel/back can restore form data instead of dropping it.
  // Cleared on successful save.
  CreateInvoiceFormState: "cifs",
  CheckoutInvoiceId: "ciid",
  // Platform checkout (system invoices — subscription/listing/application fee).
  // Caller sets these before navigating to routeNames.platformcheckout.
  PlatformCheckoutInvoiceId: "pciid",
  PlatformCheckoutReturnUrl: "pcret",
  PlatformCheckoutAllowSkip: "pcskip",
  // Breadcrumb origin label. E.g. "Applications" (yields "Applications > Checkout").
  PlatformCheckoutOriginLabel: "pcorlbl",
  // Success-card CTA label. Caller sets this so the button reads like the
  // *next* step (e.g. "Continue to Application Form") instead of the generic
  // "Back to <origin>". Falls back to "Back to <origin>" when unset.
  PlatformCheckoutSuccessLabel: "pcsuclbl",
  ViewApplicationId: "vappid",
  ViewApplicationForm: "vappf",
  SenderViewApplicationForm: "svappf",
  LogininEmail: "lem",
  CreateProfileId: "cpi",
  CreateConnectionDetails: "ccd",
  CreateMemberDetails: "cmd",
  ViewEditBusinessId: "vebid",
  ViewEditBrandingId: "vebrid",
  ViewEditBusinessMemberId: "vebmid",
  EditBusinessId: "ebid",
  ViewNotificationId: "vnid",
};
/*Session storage keys*/

/*User cookie keys */
export const UserCookie = {
  CookieName: "_u",
  AccountId: "accid",
  Email: "em",
  PlanId: "plid",
  Plan: "pl",
  IsSetupCompleted: "isc",
  Profile: "p",
  ProfileId: "pid",
  Name: "name",
  ProfilePic: "pic",
  ProfileTypeId: "ptid",
  ProfileType: "pt",
  AccountTypeId: "atid",
  AccountType: "at",
  CountryId: "cid",
  ProfileCategoryIds: "pcids",
  SessionId: "sessid",
};
/*User cookie keys */

/*Api Request Actions*/
export const API_ACTION_STATUS = Object.freeze({
  START: "start",
  COMPLETED: "completed",
});
/*Api Request Actions*/

/*Grid default values*/
const GRID_MOBILE_PAGE_SIZE = 20;
const GRID_MOBILE_BREAKPOINT = 768;

export const isGridMobileViewport = () =>
  typeof window !== "undefined" && window.innerWidth < GRID_MOBILE_BREAKPOINT;

export const getResponsiveGridDefaultPageSize = (defaultPageSize) =>
  isGridMobileViewport() ? GRID_MOBILE_PAGE_SIZE : defaultPageSize;

export const GridDefaultValues = {
  pi: 0,
  get ps() {
    return getResponsiveGridDefaultPageSize(10);
  },
  ps5: 5,
  ps3: 3,
  get ps9() {
    return getResponsiveGridDefaultPageSize(9);
  },
  get ps12() {
    return getResponsiveGridDefaultPageSize(12);
  },
  ps11: 11,
  get ps14() {
    return getResponsiveGridDefaultPageSize(14);
  },
  get ps19() {
    return getResponsiveGridDefaultPageSize(19);
  },
  ps20: GRID_MOBILE_PAGE_SIZE,
  all: -1,
};
/*Grid default values*/

/*connection tab ids*/
export const UserConnectionTabIds = {
  requested: "#tab-requested",
  joined: "#tab-joined",
  connection: "#tab-connection",
};
/*connection tab ids*/

/*documents tab ids*/
export const DocumentsTabIds = {
  mydocuments: "#tab-mydocuments",
  shareddocuments: "#tab-shared",
};
/*connection tab ids*/

/*file upload progess states*/
export const UploadProgressState = {
  NotStarted: 0,
  Started: 1,
  Uploading: 2,
  Completed: 3,
};
/*file upload progess states*/

export const defaultRegFormData = {
  txtemail: "",
  rblprofiletype: "",
  rblaccountType: "",
  txtfirstname: "",
  txtlastname: "",
  txtmobile: "",
  accountid: 0,
  txtpassword: "",
  txtconfirmpassword: "",
  cbterms: false,
  catids: [],
  currstep: config.userRegSteps.Email,
  oauthproviderid: config.OAuthProviders.None.id,
};

/*Common App messages*/
export const AppMessages = {
  DdlDefaultSelect: " Select ",
  DdlTypetoSearch: "Type to search ",
  DdlTypetoSearchByEmailorPh: "Search by Email or Phone",
  DdlNoData: "No data found.",
  DdLLoading: "Loading...",
  NoCountries: "No countires found.",
  NoStates: "No states found.",
  NoCities: "No cities found.",
  NoData: "No data found...",
  NoUsers: "No users found...",
  NoMembers: "No members found...",
  NoDocuments: "No documents found...",
  NoAgreements: "No agreements found...",
  NoTemplates: "No templates found...",
  NoHistory: "No history found...",
  NoProfiles: "No profiles found...",
  NoProfileTypes: "No profile types found...",
  NoProperties: "No properties found...",
  Nolistedproperties: "No listed properties found...",
  NoInvoices: "No invoices found...",
  InvoiceNotFound: "Invoice details not found...",
  NoAccounts: "No accounts found...",
  AccountDetailsNotFound: "Account details not found...",
  PasswordResetLinkExpired:
    "Your password reset link has expired. Please request a new one.",
  NoServiceRequests: "No service requests found...",
  NoItems: "No items found...",
  NoBusinesses: "No business found...",
  NoConnectedProperties: "No connected properties found...",
  NoAssignedProperties: "No assigned properties found...",
  NoPayments: "No payments found...",
  NoPropertyDetails: "Property details not found...",
  NoConnection: `No connections found...`,
  NoReports: `No reports found...`,
  NoTenants: `No ${Object.keys(config.userProfileTypes)
    .find(
      (key) => config.userProfileTypes[key] === config.userProfileTypes.Tenant,
    )
    .toLowerCase()}s found...`,
  NoTenantRequests: `No ${Object.keys(config.userProfileTypes)
    .find(
      (key) => config.userProfileTypes[key] === config.userProfileTypes.Tenant,
    )
    .toLowerCase()} requests found...`,
  NoAgents: `No ${Object.keys(config.userProfileTypes)
    .find(
      (key) => config.userProfileTypes[key] === config.userProfileTypes.Agent,
    )
    .toLowerCase()}s found...`,
  NoAgentRequests: `No ${Object.keys(config.userProfileTypes)
    .find(
      (key) => config.userProfileTypes[key] === config.userProfileTypes.Agent,
    )
    .toLowerCase()} requests found...`,
  NoOwners: `No ${Object.keys(config.userProfileTypes)
    .find(
      (key) => config.userProfileTypes[key] === config.userProfileTypes.Owner,
    )
    .toLowerCase()}s found...`,
  NoOwnerRequests: `No ${Object.keys(config.userProfileTypes)
    .find(
      (key) => config.userProfileTypes[key] === config.userProfileTypes.Owner,
    )
    .toLowerCase()} requests found...`,
  SomeProblem: "Some problem occured, Please try again.",
  AsyncSelectNoData: [{ Id: "", Text: "No data found." }],
  AsyncSelectDefaultSelect: [{ Id: "", Text: " Select " }],
  DeleteConfirmationTitle: "Are you sure?",
  DownloadConfirmationTitle: "Download Confirmation",
  UnlistConfirmationTitle: "Unlist Business",
  DeleteAssetConfirmationMessage: "You want to delete {propertyname} property.",
  UnlistAssetConfirmationMessage:
    "Are you sure you want to unlist this property?",
  UnlistBusinessConfirmationMessage:
    "Are you sure you want to unlist '{companyname}'?",
  SendInvitaionModalTitle: "Send Invitation",
  SendMessageModalTitle: "Send Message",
  AddBusinessSuccess: "Business Created Successfully...",
  UpdateBusinessSuccess: "Business Updated Successfully...",
  AddPropertySuccess: "Property created successfully...",
  UpdatePropertySuccess: "Property details updated successfully...",
  AddAssetOwnersSuccess: "Owner details saved successfully...",
  DeleteAssetSuccess: "Property deleted successfully...",
  DeleteImageSuccess: "Image deleted successfully...",
  DeleteAssetOwnerSuccess: "Owner removed successfully...",
  NoNewNotifications: "No new notifications...",
  DeleteNotificationConfirmationMessage:
    "You want to delete '{notificationmessage}' notification.",
  DeleteNotificationSuccess: "Notification deleted successfully...",
  NoNotifications: "No notifications found...",
  SendNotificationModalTitle: "Send Notification",
  SendPaymentNotificationModalTitle: "Send Payment Notification",
  SupportTicketSuccess:
    "Your message has been sent. We will get back to you shortly.",
  ScheduleDemoSuccess:
    "Demo request received. Our team will contact you shortly.",
  ProfileDetailsNotFound: "Profile details not found...",
  CreateProfileSuccess: "Profile created successfully...",
  UpdateProfileSuccess: "Profile details updated successfully...",
  CreateUserBrandingSuccess: "Branding details updated successfully...",
  CreateScurityPinSuccess: "SecurityPin Created Successfully...",
  NoAgreementTemplates: "No templates found...",
  MyAgreements: "My Agreements",
  AgreementTemplates: "Agreement Templates",
  DeleteUserAgreementMessage: "You want to delete the {name}.",
  RenameUserAgreementModalTitle: "Rename Agreement",
  DownloadUserAgreementMessage:
    "This will download <span class='font-general font-500'>{name}</span> to your device. Continue?.",
  UserAgreementRemoveAccessMessage: "You want to remove access for {name}.",
  NoUserAgreementorFolderDetails: `No agreement or folder details found.`,
  // Agreement deeplink access/error messages.
  NoAgreementAccess: `You do not have permission to access this agreement.`,
  InvalidAgreementLink:
    "Unable to open agreement. The link appears to be corrupted or invalid.",
  NoDocumentorFolderDetails: `No document or folder details found.`,
  NoDocumentDetails: `No document details found.`,
  NoDocumentFile: `Document file not found.`,
  NoDocumentAccess: `You do not have permission to access this document.`,
  InvalidDocumentLink:
    "Unable to open document. The link appears to be corrupted or invalid.",
  FailedDocumentLoad: "Failed to load document. Please try again later.",
  NoDocumentFolderDetails: `No folder details found.`,
  DeleteDocumentMessage: "You want to delete the {name}.",
  DeleteTemplateMessage: "You want to delete the {name}.",
  DownloadDocumentMessage:
    "This will download <span class='font-general font-500'>{name}</span> to your device. Continue?.",
  RenameFolderModalTitle: "Rename Folder",
  RenameDocumentModalTitle: "Rename Document",
  RenameTemplateModalTitle: "Rename Template",
  EditTemplateCategoryModalTitle: "Edit Category",
  FolderInfoModalTitle: "Folder Details",
  FileInfoModalTitle: "File Details",
  SetDocumentPinModalTitle: "Set Document PIN",
  ShareFolderModalTitle: "Share Folder",
  DdlNoFolders: "No folders found.",
  AddDocumentSuccess: "Document added successfully...",
  AddFolderModalTitle: "Create folder",
  UploadDocumentSuccess: "Documents uploaded successfully...",
  DocumentRemoveAccessMessage: "You want to remove access for {name}.",
  NoAssetMedia: "No media info...",
  AssetOwnersRequired: "Please select owners...",
  AssetImagesRequired: "Please select files to upload...",
  AssetAssignUsersRequired: "Please select users...",
  ListPropertyModalTitle: "List Property",
  ListBusinessModalTitle: "List Business",
  ListingInfoModalTitle: "Listing Information",
  SwitchClassificationModalTitle: "Switch Zone",
  AssetListSuccess: "Property listed successfully...",
  BusinessListSuccess: "Business listed successfully...",
  UpdateListingInfoSuccess: "Listing information saved successfully...",
  AssetUnlistSuccess: "Property unlisted successfully...",
  AssetSwitchClassificationSuccess: "Property zone switched successfully...",
  PaymentSubaccountDetailsNotFound: "Payment account details not found...",
  PaymentSubaccountAlreadyActivated: "Payment account already activated...",
  PaymentSubaccountProcessing: "Payment account creation is in processing...",
  PaymentSubaccountRejected: "Payment account has been rejected...",
  PaymentSubaccountCreatedSuccess: "Payment account created successfully...",
  AccountCreationRestrictedTitle: "Account Creation Restricted!",
  AccountCreationRestrictedModalMessage:
    "You can not create a new account while your current account is still under processing. Please wait for the current process to be completed.",
  DeleteInvoiceItemConfirmationMessage: "You want to delete {item}.",
  DdlSelectItem: "Select Item",
  DdlSelectBusiness: "Select Business",
  SendInvoiceModalTitle: "Send Invoice",
  UnsendInvoiceToUserMessage: "You want to unsend invoice for {name}.",
  InvoiceSendNoSubAccountAlertTitle: "Warning: No Payment Account Created!",
  InvoiceSendNoSubAccountMessage:
    "You do not have a created payment account. We cannot process payments without a payment account. Are you sure you want to continue?",
  CheckoutNoSubAccountAlertTitle: "Warning: No Active Payment Account!",
  CheckoutNoSubAccountMessage:
    "The invoice creator does not have an active payment account. Payment cannot be initiated.",
  AddInvocieItemModalTitle: "Add New Item",
  DeleteInvitationConfirmationMessage:
    "You want to delete the {profiletype} invitation request for {email}.",
  DeleteInvitationSuccess: "Invitation deleted successfully...",
  DeleteInvoiceConfirmationMessage:
    "You want to delete the <span class='font-general font-500'>invoice#: {invoicenumber}.<span>",
  DeleteInvoiceSuccess: "Invoice deleted successfully...",
  CancelInvoiceConfirmationMessage:
    "You want to cancel the <span class='font-general font-500'>invoice#: {invoicenumber}.</span>",
  CancelInvoiceSuccess: "Invoice canceled successfully...",
  TerminateInvitationConfirmationMessage:
    "You want to terminate the connection for {email}.",
  RemoveMemberInvitationConfirmationMessage:
    "Remove connection for {email} ? All members will be removed.",
  TerminateInvitationSuccess: "Connection termination successfully...",
  ReconnectUserTitle: "Reconnect User?",
  ReconnectConfirmationMessage:
    "You want to reconnect the {profiletype} connection for {email}.",
  ConnectUserTitle: "Connect User?",
  ConnectConfirmationMessage:
    "You want to connect the {profiletype} connection for {email}.",
  MarkasPaidConfirmationTitle: "Mark inovice as paid?",
  MarkasPaidConfirmationMessage:
    "Invoice #{invoicenumber} will be marked as paid. This action cannot be undone.",
  NoTestimonials: "No testimonials found...",
  NoApplications: "No applications found...",
  DeleteApplicationConfirmationMessage:
    "You want to delete the application#: {applicationnumber}.",
  DeleteApplicationSuccess: "Application deleted successfully...",
  SendApplicationModalTitle: "Send Application",
  UnsendApplicationToUserMessage: "You want to unsend application for {name}.",
  NoUserAccount: "No account found with this email. Please try again.",
  DeleteBusinessConfirmationMessage:
    "Deleting <span class='font-15 font-500'>{companyname}</span> will permanently remove all related data. This action cannot be undone. Do you want to continue?",
  DeleteBusinessImageConfirmationMessage: "Do You want to delete the image?",
  ListBusinessConfirmationMessage:
    "Listing <span class='font-15 font-500'>{companyname}</span> will listing the information",
  DeleteBusinessMemberConfirmationMessage:
    "You want to delete the invitation request for {email}.",
  BusinessUnlistSuccess: "Business unlisted successfully...",
  ApplicationDetailsNotFound: "Application details not found...",
  ApplicationSubmitSuccess:
    "Your application has been successfully submitted...",
  DeleteServiceConfirmationMessage:
    "You want to delete the <span class='font-general font-500'>request#: {requestnumber}.<span>",
  DeleteDocumentSuccess: "Document deleted successfully...",
  UpdateServicesSuccess: "Service Details Updated Successfully....",
  CancelServiceConfirmationMessage:
    "You want to cancel the <span class='font-general font-500'>Request#: {requestnumber}.</span>",
  ResolveServiceConfirmationMessage:
    "You want to Resolve the <span class='font-general font-500'>Request#: {requestnumber}.</span>",
  CloseReopenServiceConfirmationMessage:
    "You want to Close/Reopen the <span class='font-general font-500'>Request#: {requestnumber}.</span>",
  ReopenServiceConfirmationMessage:
    "You want to Reopen the <span class='font-general font-500'>Request#: {requestnumber}.</span>",
  RequestSentSuccess: "Request sent successfully.",
  RequestNotFound: "Service request details not found.",
  RequestAlreadyExist: "Service request already sent to this account.",
  DeleteSentServiceRequestMessage: "Sent service request deleted successfully.",
  DeletedServiceRequestToUserMessage:
    "You want to delete service request for {name}.",
  SendRequestModalTitle: "Send Request",
  UpdateServiceRequestComment: "Comment updated successfully.",
  CommentDeleteSuccess: "Comment deleted successfully.",
  LinkCopiedSuccess: "Link copied to clipboard.",
  RemoveSeurityPin: "You want to Remove the Secirity Pin",
};
/*Common App messages*/

export const ValidationMessages = {
  NameReq: "Name can not be empty.",
  OccupationReq: "Occupation can not be empty.",
  TestimonialReq: "Testimonial can not be empty.",
  TestimonialInvalid: "Testimonial should be minimum 50 to 500 characters.",
  DBANameReq: "DBA Name can not be empty.",
  DBANameInvalid: "DBA Name should be minimum 2 to 50 characters.",
  LegalNameReq: "Legal Name can not be empty.",
  LegalNameInvalid: "Legal Name should be minimum 2 to 50 characters.",
  AccountNumberReq: "Account Number can not be empty.",
  AccountNumberInvalid: "Account Number should be minimum 4 to 17 characters.",
  RoutingNumberReq: "Routing Number can not be empty.",
  RoutingNumberInvalid: "Routing Number should be 9 characters.",
  BusinessDescriptionReq: "Description can not be empty.",
  BusinessNameOnAccountReq: "Business Name on Account can not be empty.",
  FNameReq: "Firstname can not be empty.",
  MNameReq: "Middlename can not be empty.",
  LNameReq: "Lastname can not be empty.",
  BrandingHeaderReq: "Header text can not be empty.",
  BrandingFooterReq: "Footer text can not be empty.",
  EmailReq: "Email address can not be empty.",
  EmailInvalid: "Email address is not valid.",
  PwdReq: "Password can not be empty.",
  PwdInvalid: "Password should be minimum 6 to 30 characters.",
  CpwdReq: "Confirm password can not be empty.",
  CpwdInvalid: "Confirm password should be minimum 6 to 30 characters.",
  CpwdMatch: "Confirm password and passwords are not same.",
  CurrentPwdReq: "Current password can not be empty.",
  CurrentPwdInvalid: "Current password should be minimum 6 to 30 characters.",
  NewPwdReq: "New password can not be empty.",
  NewPwdInvalid: "New password should be minimum 6 to 30 characters.",
  CNewpwdReq: "Confirm new password can not be empty.",
  CNewpwdInvalid: "Confirm new password should be minimum 6 to 30 characters.",
  CNewpwdMatch: "Confirm new password and new passwords are not same.",
  MobileReq: "Mobile number can not be empty.",
  MobileInvalid: "Mobile number is not valid.",
  LandlineReq: "Landline number can not be empty.",
  LandlineInvalid: "Landline number is not valid.",
  PhoneReq: "Phone number can not be empty.",
  PhoneInvalid: "Phone number is not valid.",
  CompanynameReq: "Company name can not be empty.",
  WebsiteReq: "Website can not be empty.",
  WebsiteInvalid: "Website is not valid.",
  ZipReq: "Zip code can not be empty.",
  ZipInvalid: "Zip code is not valid.",
  SSNReq: "SSN can not be empty.",
  SSNInvalid: "SSN is not valid.",
  EINReq: "Company EIN can not be empty.",
  EINInvalid: "Company EIN is not valid.",
  Last4SSNReq: "Last 4 SSN can not be empty.",
  Last4SSNInvalid: "Last 4 SSN is not valid.",
  FederalTaxIDReq: "Federal Tax ID can not be empty.",
  FederalTaxIDInvalid: "Federal Tax ID is not valid.",
  CardNumberReq: "Card number can not be empty.",
  CardNumberInvalid: "Card number is not valid.",
  CardExpiryReq: "Card expiry date can not be empty.",
  CardExpiryInvalid: "Card expiry date is not valid.",
  CvvReq: "CVV can not be empty.",
  CvvInvalid: "CVV is not valid.",
  ProfiletypeReq: "Profile type can not be empty.",
  CategoryReq: "Category can not be empty.",
  ServicesReq: "Service can not be empty.",
  CountryReq: "Country can not be empty.",
  CountryInvalid: "Country is not valid.",
  ContactforReq: "Contact for can not be empty.",
  StateReq: "State can not be empty.",
  StateInvalid: "State is not valid.",
  CityReq: "City can not be empty.",
  CityInvalid: "City is not valid.",
  TermsReq: "Please check the terms.",
  SubjectReq: "Subject can not be empty.",
  MessageReq: "Message can not be empty.",
  AboutmeReq: "Aboutme can not be empty.",
  AboutcompanyReq: "About company can not be empty.",
  SearchKeywordReq: "Keyword can not be empty.",
  LocationReq: "Location can not be empty.",
  FileReq: "File can not be empty.",
  FileFormatInvalid: "File format is invalid.",
  FileSizeInvalid: "File size exceeds the limit of",
  DateReq: "Date can not be empty.",
  DateInvalid: "Date is not valid.",
  TenureStartDateReq: "Tenure start date can not be empty.",
  TenureStartDateInvalid: "Tenure start date is not valid.",
  TenureEndDateReq: "Tenure end date can not be empty.",
  TenureEndDateDateInvalid: "enure end date is not valid.",
  RentPaidToReq: "Rent paid to can not be empty.",
  PropertyReq: "Property can not be empty.",
  TenantReq: "Tenant can not be empty.",
  AgentReq: "Agent can not be empty.",
  OwnerReq: "Owner can not be empty.",
  UserReq: "User can not be empty.",
  MemberReq: "Member can not be empty.",
  PropertyTitleReq: "Property title can not be empty.",
  PropertyTitleInvalid: "Property title is not valid.",
  AddressReq: "Address can not be empty.",
  AddressInvalid: "Address is not valid.",
  CurAddressReq: "Current address can not be empty.",
  CurAddressInvalid: "Current address 1 is not valid.",
  Address1Req: "Address 1 can not be empty.",
  Address1Invalid: "Address 1 is not valid.",
  Address2Req: "Address 2 can not be empty.",
  Address2Invalid: "Address 2 is not valid.",
  DescriptionReq: "Description can not be empty.",
  DescriptionInvalid: "Description is not valid.",
  StartEndDateGreater: "End date should be grater than Start date.",
  ContractTypeReq: "Contract type can not be empty.",
  ListingTypeReq: "Listing type can not be empty.",
  AssetTypeReq: "Property type can not be empty.",
  AccessTypeReq: "Access type can not be empty.",
  BedroomsReq: "Bedrooms can not be empty.",
  BathroomsReq: "Bathrooms can not be empty.",
  RentReq: "Rent amount can not be empty.",
  RentInvalid: "Rent amount is not valid.",
  AdvanceReq: "Advance amount can not be empty.",
  AdvanceInvalid: "Advance amount is not valid.",
  AmountReq: "Amount can not be empty.",
  AmountInvalid: "Amount is not valid.",
  PriceReq: "Price can not be empty.",
  PriceInvalid: "Price is not valid.",
  NooffloorsReq: "Nooffloors can not be empty.",
  NooffloorsInvalid: "Nooffloors is not valid.",
  AreaReq: "Area can not be empty.",
  AreaInvalid: "Area is not valid.",
  SqfeetReq: "Squarefeet can not be empty.",
  SqfeetInvalid: "Squarefeet is not valid.",
  AgentPercentReq: "Agent percentage can not be empty.",
  AgentPercentInvalid: "Agent percentage is not valid.",
  FeePercentReq: "Fee percentage can not be empty.",
  FeePercentInvalid: "Fee percentage is not valid.",
  OwnershipPercentReq: "Ownership percentage can not be empty.",
  OwnershipPercentInvalid: "Ownership percentage is not valid.",
  TitleReq: "Title can not be empty.",
  TitleInvalid: "Title is not valid.",
  CommentsReq: "Comments can not be empty.",
  DocumentTypeReq: "Document type can not be empty.",
  UploadFileReq: "Please select files to upload.",
  UploadMin1DocReq: "Please select minimum 1 document to upload.",
  UploadMin2DocsReq: "Please select minimum 2 documents to upload.",
  ItemForTypeReq: "Item for type can not be empty.",
  ItemReq: "Item can not be empty.",
  AccountForTypeReq: "Account for type can not be empty.",
  AccountTypeReq: "Account type can not be empty.",
  AuthorizePaymentReq:
    "Please authorize the payment to continue.",
  InvoiceNumReq: "Invoice number can not be empty.",
  InvoiceNumInvalid: "Invoice number is not valid.",
  PaymentTransactionReq: "Transaction can not be empty.",
  TransactionRefNumberReq: "Transaction ref number can not be empty.",
  QtyReq: "Quantity code can not be empty.",
  QtyInvalid: "Quantity code is not valid.",
  MaxFileSizeReached: "Maximum file size reached.",
  MaxFileLimitReaced: "Maximum files limit reached.",
  UploadValidFiles: "Some files were rejected. Please upload valid files.",
  ApplicationTypeReq: "Application type can not be empty.",
  ResidencetypeReq: "Residence type can not be empty.",
  OwnerhipstatustypeReq: "Ownership status can not be empty.",
  NoofPetsReq: "Number of pets can not be empty.",
  NoofResidentsReq: "Number of residents can not be empty.",
  AnyoneSmokeReq: "Please select if anyone smokes.",
  EmploymenttypeReq: "Employment type can not be empty.",
  BusinessReq: "Business can not be empty.",
  SharePercentReq: "Share percentage can not be empty.",
  SharePercentInvalid: "Share percentage is not valid.",
  BillfromReq: "Billfrom can not be empty.",
  BilltoReq: "Billto can not be empty.",
  PaymentMethodsReq: "Select at least one payment method.",
  SecurityPinReq: "PIN can not be empty.",
  SecurityPinInvalid: "PIN should be minimum 4 to 6 characters.",
  CurrentPinReq: "Current PIN can not be empty.",
  CurrentPinInvalid: "Current PIN should be minimum 4 to 6 characters.",
  NewPinReq: "New PIN can not be empty.",
  NewPinInvalid: "New PIN should be minimum 4 to 6 characters.",
};

/*Api Urls*/
export let ApiUrls = {
  getToken: `token/v1/GetToken`,
  getDdlCountries: `common/v1/GetDdlCountries`,
  getDdlStates: `common/v1/GetDdlStates`,
  getDdlCities: `common/v1/GetDdlCities`,
  getDdlSupportTypes: `common/v1/GetDdlSupportTypes`,
  getAppConfig: `common/v1/GetAppConfig`,
  createScheduleDemo: `common/v1/CreateScheduleDemo`,
  createTestimonial: `common/v1/CreateTestimonial`,
  getSupportTickets: `common/v1/GetSupportTickets`,
  getTestimonials: `common/v1/GetTestimonials`,
  getListedBusinesses: `users/v1/GetListedBusinesses`,
  getOccupationTypes: `common/v1/GetOccupationTypes`,
  getResidenceOwnerShipTypes: `common/v1/GetResidenceOwnerShipTypes`,
  getResidenceTypes: `common/v1/GetResidenceTypes`,
  getEmploymentTypes: `common/v1/GetEmploymentTypes`,
  oAuthUser: `users/v1/OAuthUser`,
  registerUser: `users/v1/RegisterUser`,
  getProfileTypes: `users/v1/GetProfileTypes`,
  getProfileCategories: `users/v1/GetProfileCategories`,
  sendUserEnquiry: `users/v1/SendUserEnquiry`,
  updateUser: `users/v1/UpdateUser`,
  login: `users/v1/Login`,
  logout: `users/v1/Logout`,
  checkUserAccountByEmail: `users/v1/CheckUserAccountByEmail`,
  checkUserProfileByEmail: `users/v1/CheckUserProfileByEmail`,
  changePassword: `users/v1/ChangePassword`,
  sendResetPassword: `users/v1/SendResetPassword`,
  resetPassword: `users/v1/ResetPassword`,
  updateProfileType: `users/v1/UpdateProfileType`,
  createUserProfile: `users/v1/CreateUserProfile`,
  updateAccountType: `users/v1/UpdateAccountType`,
  updateUserAccountSetupComplete: `users/v1/UpdateUserAccountSetupComplete`,
  updateProfileCategories: `users/v1/UpdateProfileCategories`,
  updateBusiness: `users/v1/UpdateBusiness`,
  getMembersByBusinessId: `users/v1/GetMembersByBusinessId`,
  setBusinessListStatus: `users/v1/SetBusinessListStatus`,
  listBusiness: `users/v1/ListBusiness`,
  addEditBusinessImages: `users/v1/AddEditBusinessImages`,
  deleteBusiness: `users/v1/DeleteBusiness`,
  deleteBusinessImage: `users/v1/DeleteBusinessImage`,
  updateBusinessMember: `users/v1/UpdateBusinessMember`,
  createBusinessMember: `users/v1/CreateBusinessMember`,
  deleteBusinessMember: `users/v1/DeleteBusinessMember`,
  getUserProfiles: `users/v1/GetUserProfiles`,
  upgradePlan: `users/v1/UpgradePlan`,
  getTopAgents: `users/v1/GetTopAgents`,
  getDdlUsersProfiles: `users/v1/GetDdlUsersProfiles`,
  getDdlUsers: `users/v1/GetDdlUsers`,
  getUserConnectionsCount: `users/v1/getUserConnectionsCount`,
  getUserConnections: `users/v1/getUserConnections`,
  getUserConnection: `users/v1/GetUserConnection`,
  getDdlJoinedUserConnections: `users/v1/GetDdlJoinedUserConnections`,
  getJoinedUserConnections: `users/v1/GetJoinedUserConnections`,
  getRequestedUserConnections: `users/v1/getRequestedUserConnections`,
  getUserConnectionsHistory: `users/v1/getUserConnectionsHistory`,
  updateUserConnectionStatus: `users/v1/UpdateUserConnectionStatus`,
  createUserConnection: `users/v1/CreateUserConnection`,
  updateUserConnection: `users/v1/UpdateUserConnection`,
  deleteRegistrationInvitation: `users/v1/DeleteRegistrationInvitation`,
  getUserDetails: `users/v1/GetUserDetails`,
  checkProfileByProfileTypeId: `users/v1/CheckProfileByProfileTypeId`,
  getUserBusinesses: `users/v1/GetUserBusinesses`,
  getDdlBusiness: `users/v1/GetDdlBusinesses`,
  getUserBusinessDetails: `users/v1/GetUserBusinessDetails`,
  getBusinessMembers: `users/v1/GetBusinessMembers`,
  GetBusinessMemberDetails: `users/v1/GetBusinessMemberDetails`,
  getBusinessParentMembers: `users/v1/GetBusinessParentMembers`,
  getBusinessMemberSubMembers: `users/v1/GetBusinessMemberSubMembers`,
  updateBusinessMemberStatus: `users/v1/UpdateBusinessMemberStatus`,
  deleteBusinessMemberInvitation: `users/v1/DeleteBusinessMemberInvitation`,
  getUserAccountDetails: `users/v1/GetUserAccountDetails`,
  getUserBrandingDetails: `users/v1/GetUserBrandingDetails`,
  createUserBranding: `users/v1/CreateUserBranding`,
  switchUserProfileBranding: `users/v1/SwitchUserProfileBranding`,
  getAgents: `users/v1/GetAgents`,
  getAssetTypes: `assets/v1/GetAssetTypes`,
  getAssetListingTypes: `assets/v1/GetAssetListingTypes`,
  getAssetAcccessTypes: `assets/v1/GetAssetAccessTypes`,
  getAssetsAppConfig: `assets/v1/GetAssetsAppConfig`,
  addAsset: `assets/v1/AddAsset`,
  editAssetInformation: `assets/v1/EditAssetInformation`,
  addEditAssetImages: `assets/v1/AddEditAssetImages`,
  addEditAssetOwners: `assets/v1/AddEditAssetOwners`,
  addAssetImages: `assets/v1/AddAssetImages`,
  listAsset: `assets/v1/ListAsset`,
  unlistAsset: `assets/v1/UnlistAsset`,
  switchAssetClassification: `assets/v1/SwitchAssetClassification`,
  getUserAssets: `assets/v1/GetUserAssets`,
  getUserPartnerOwnerAssets: `assets/v1/GetUserPartnerOwnerAssets`,
  getUserAssignedAssets: `assets/v1/GetUserAssignedAssets`,
  getUserConnectedAssets: `assets/v1/GetUserConnectedAssets`,
  getAssets: `assets/v1/GetAssets`,
  getAssetDetails: `assets/v1/GetAssetDetails`,
  getUserAssetDetails: `assets/v1/GetUserAssetDetails`,
  getAssetAssignedProfiles: `assets/v1/GetAssetAssignedProfiles`,
  getDdlAssetsUnassignedProfiles: `assets/v1/GetDdlAssetsUnassignedProfiles`,
  assignAsset: `assets/v1/AssignAsset`,
  unassignAsset: `assets/v1/UnassignAsset`,
  deleteAsset: `assets/v1/DeleteAsset`,
  deleteAssetImage: `assets/v1/DeleteAssetImage`,
  deleteAssetOwner: `assets/v1/DeleteAssetOwner`,
  getTopAssets: `assets/v1/GetTopAssets`,
  getDdlUserAssets: `assets/v1/GetDdlUserAssets`,
  getAreaUnitTypes: `assets/v1/GetAreaUnitTypes`,
  getPricingPlans: `plans/v1/GetPricingPlans`,
  getTopNotifications: `notifications/v1/GetTopNotifications`,
  updateNotificationRead: `notifications/v1/UpdateNotificationRead`,
  getDdlNotificationTypes: `notifications/v1/GetDdlNotificationTypes`,
  getNotifications: `notifications/v1/GetNotifications`,
  getNotificationDetails: `notifications/v1/GetNotificationDetails`,
  deleteNotification: `notifications/v1/DeleteNotification`,
  createNotification: `notifications/v1/CreateNotification`,
  createAssetPayment: `payments/v1/CreateAssetPayment`,
  getAssetPayments: `payments/v1/GetAssetPayments`,
  getAssetPaymentDetails: `payments/v1/GetAssetPaymentDetails`,
  processAssetPayment: `payments/v1/ProcessAssetPayment`,
  getPaymentChannels: `payments/v1/GetPaymentChannels`,
  getPaymentSubAccounts: `payments/v1/GetPaymentSubAccounts`,
  getPaymentSubAccountsCountByStatus: `payments/v1/GetPaymentSubAccountsCountByStatus`,
  getPaymentSubAccountDetails: `payments/v1/GetPaymentSubAccountDetails`,
  createSubAccount: `payments/v1/CreateSubAccount`,
  getInvoiceItemForTypes: `payments/v1/GetInvoiceItemForTypes`,
  getInvoiceItemAccountForTypes: `payments/v1/GetInvoiceItemAccountForTypes`,
  getDdlInvoiceForItems: `payments/v1/GetDdlInvoiceForItems`,
  addInvoiceItem: `payments/v1/AddInvoiceItem`,
  getInvoiceItems: `payments/v1/GetInvoiceItems`,
  deleteInvoiceItem: `payments/v1/DeleteInvoiceItem`,
  getInvoiceItemDetails: `payments/v1/GetInvoiceItemDetails`,
  getDdlInvoiceItems: `payments/v1/GetDdlInvoiceItems`,
  generateInvoiceNumber: `payments/v1/GenerateInvoiceNumber`,
  createInvoice: `payments/v1/CreateInvoice`,
  updateInvoice: `payments/v1/UpdateInvoice`,
  setInvoiceTempToActive: `payments/v1/SetInvoiceTempToActive`,
  deleteInvoice: `payments/v1/DeleteInvoice`,
  updateInvoiceStatus: `payments/v1/UpdateInvoiceStatus`,
  sendInvoiceEmailToUsers: `payments/v1/SendInvoiceEmailToUsers`,
  getInvoices: `payments/v1/GetInvoices`,
  getInvoiceDetails: `payments/v1/GetInvoiceDetails`,
  getInvoicePayments: `payments/v1/GetInvoicePayments`,
  getInvoicePdf: `payments/v1/GetInvoicePdf`,
  getInvoicePdfDetails: `payments/v1/GetInvoicePdfDetails`,
  getReceiptPdfDetails: `payments/v1/GetReceiptPdfDetails`,
  sendInvoice: `payments/v1/SendInvoice`,
  unsendInvoice: `payments/v1/UnsendInvoice`,
  getSentInvoices: `payments/v1/GetSentInvoices`,
  createPaymentTransaction: `payments/v1/CreatePaymentTransaction`,
  createPaymentCard: `payments/v1/CreatePaymentCard`,
  getPaymentCards: `payments/v1/GetPaymentCards`,
  getPaymentCardByAwToken: `payments/v1/GetPaymentCardByAwToken`,
  deletePaymentCard: `payments/v1/DeletePaymentCard`,
  getPaymentCardStatus: `payments/v1/GetPaymentCardStatus`,
  markInvoiceAsPaid: `payments/v1/MarkInvoiceAsPaid`,
  calculatePaymentAmount: `payments/v1/CalculatePaymentAmount`,
  createRecurringInvoice: `payments/v1/CreateRecurringInvoice`,
  updateRecurringInvoice: `payments/v1/UpdateRecurringInvoice`,
  getRecurringInvoices: `payments/v1/GetRecurringInvoices`,
  getRecurringInvoiceDetails: `payments/v1/GetRecurringInvoiceDetails`,
  pauseRecurringInvoice: `payments/v1/PauseRecurringInvoice`,
  resumeRecurringInvoice: `payments/v1/ResumeRecurringInvoice`,
  cancelRecurringInvoice: `payments/v1/CancelRecurringInvoice`,
  createRecurringPayment: `payments/v1/CreateRecurringPayment`,
  authorizeRecurringPayment: `payments/v1/AuthorizeRecurringPayment`,
  getRecurringPayments: `payments/v1/GetRecurringPayments`,
  getRecurringPaymentDetails: `payments/v1/GetRecurringPaymentDetails`,
  pauseRecurringPayment: `payments/v1/PauseRecurringPayment`,
  resumeRecurringPayment: `payments/v1/ResumeRecurringPayment`,
  cancelRecurringPayment: `payments/v1/CancelRecurringPayment`,
  getAgreementTemplates: `agreements/v1/GetTemplates`,
  getAgreementTemplateDetails: `agreements/v1/GetTemplateDetails`,
  getAgreementTemplateFile: `agreements/v1/GetTemplateFile`,
  getAgreementTemplateCategories: `agreements/v1/GetTemplateCategories`,
  createUserAgreementTemplate: `agreements/v1/CreateUserAgreementTemplate`,
  getUserAgreementTemplates: `agreements/v1/GetUserAgreementTemplates`,
  getUserAgreementTemplateDetails: `agreements/v1/GetUserAgreementTemplateDetails`,
  updateUserAgreementTemplateName: `agreements/v1/UpdateUserAgreementTemplateName`,
  updateUserAgreementTemplateCategory: `agreements/v1/UpdateUserAgreementTemplateCategory`,
  deleteUserAgreementTemplate: `agreements/v1/DeleteUserAgreementTemplate`,
  addUserAgreementFolder: `agreements/v1/AddUserAgreementFolder`,
  getUserAgreementsList: `agreements/v1/GetUserAgreementsList`,
  getSentUserAgreementsList: `agreements/v1/GetSentUserAgreementsList`,
  getReceivedUserAgreementsList: `agreements/v1/GetReceivedUserAgreementsList`,
  getExecutedUserAgreementsList: `agreements/v1/GetExecutedUserAgreementsList`,
  addUserAgreement: `agreements/v1/AddUserAgreement`,
  updateUserAgreement: `agreements/v1/UpdateUserAgreement`,
  updateSharedUserAgreementStatus: `agreements/v1/UpdateSharedUserAgreementStatus`,
  renameUserAgreement: `agreements/v1/RenameUserAgreement`,
  deleteUserAgreement: `agreements/v1/DeleteUserAgreement`,
  getUserAgreementFoldersHierarchy: `agreements/v1/GetUserAgreementFoldersHierarchy`,
  getUserAgreementDetails: `agreements/v1/GetUserAgreementDetails`,
  // V2 endpoint validates agreement deeplinks with logged-in user context.
  getUserAgreementDetailsV2: `agreements/v2/GetUserAgreementDetails`,
  getUserAgreementFolderDetails: `agreements/v1/GetUserAgreementFolderDetails`,
  downloadUserAgreementFolders: `agreements/v1/DownloadUserAgreementFolders`,
  getUserAgreementSharedUsers: `agreements/v1/GetUserAgreementSharedUsers`,
  updateUserAgreementAccess: `agreements/v1/UpdateUserAgreementAccess`,
  removeSharedUserAgreementAccess: `agreements/v1/RemoveSharedUserAgreementAccess`,
  shareUserAgreement: `agreements/v1/ShareUserAgreement`,
  unshareUserAgreement: `agreements/v1/UnshareUserAgreement`,
  setAgreementPin: `agreements/v1/SetAgreementPin`,
  agreementHasPin: `agreements/v1/AgreementHasPin`,
  getDocumentsList: `documents/v1/GetDocumentsList`,
  getDocumentsTypes: `documents/v1/GetDocumentTypes`,
  deleteDocument: `documents/v1/DeleteDocument`,
  setPin: `documents/v1/SetPin`,
  hasPin: `documents/v1/HasPin`,
  getDdlDocumentFolders: `documents/v1/GetDdlDocumentFolders`,
  addDocumentFolder: `documents/v1/AddDocumentFolder`,
  getSharedDocuments: `documents/v1/GetSharedDocuments`,
  shareDocument: `documents/v1/ShareDocument`,
  getDocumentDetails: `documents/v1/GetDocumentDetails`,
  getDocumentDetailsV2: `documents/v2/GetDocumentDetails`,
  getAccessibleDocuments: `documents/v1/GetAccessibleDocuments`,
  checkDocumentAccess: `documents/v1/CheckDocumentAccess`,
  getDocumentFolderDetails: `documents/v1/GetDocumentFolderDetails`,
  downloadDocumentFolders: `documents/v1/DownloadFolders`,
  getDocumentFile: `documents/v1/GetDocumentFile`,
  editDocument: `documents/v1/EditDocument`,
  addDocument: `documents/v1/AddDocument`,
  updateDocument: `documents/v1/UpdateDocument`,
  updateDocumentAccess: `documents/v1/UpdateDocumentAccess`,
  getFolderDocuments: `documents/v1/GetFolderDocuments`,
  getDocumentFoldersHierarchy: `documents/v1/GetDocumentFoldersHierarchy`,
  getDocumentSharedUsers: `documents/v1/GetDocumentSharedUsers`,
  removeSharedDocumentAccess: `documents/v1/RemoveSharedDocumentAccess`,
  unshareDocument: `documents/v1/UnshareDocument`,
  getBgvPackages: `bgv/v1/GetBgvPackages`,
  getBgvCategories: `applications/v1/GetBgvCategories`,
  getBgvApplicationTypes: `bgv/v1/GetBgvApplicationTypes`,
  getApplications: `applications/v1/GetApplications`,  
  deleteApplication: `applications/v1/DeleteApplication`,
  sendApplication: `applications/v2/SendApplication`,
  addApplicationUsers: `applications/v2/AddApplicationUsers`,
  createApplicationV2: `applications/v2/CreateApplication`,
  sendApplicationInvitationEmailsV2: `applications/v2/SendApplicationInvitationEmails`,
  unSendApplication: `applications/v1/UnSendApplication`,
  createApplication: `applications/v1/CreateApplication`,
  getApplicationDetails: `applications/v1/GetApplicationDetails`,
  getApplicationFormDetails: `applications/v1/GetApplicationFormDetails`,
  getAppFormReports: `applications/v1/GetAppFormReports`,
  getApplicationReports: `applications/v1/GetApplicationReports`,
  getAppFormPersonalInfo: `applications/v1/GetAppFormPersonalInfo`,
  updateAppFormPersonalInfo: `applications/v1/UpdateAppFormPersonalInfo`,
  getAppFormIdentityInfo: `applications/v1/GetAppFormIdentityInfo`,
  updateAppFormIdentityInfo: `applications/v1/UpdateAppFormIdentityInfo`,
  getAppFormResidenceInfo: `applications/v1/GetAppFormResidenceInfo`,
  updateAppFormResidenceInfo: `applications/v1/UpdateAppFormResidenceInfo`,
  getAppFormEmploymentInfo: `applications/v1/GetAppFormEmploymentInfo`,
  updateAppFormEmploymentInfo: `applications/v1/UpdateAppFormEmploymentInfo`,
  getAppFormEducationInfo: `applications/v1/GetAppFormEducationInfo`,
  updateAppFormEducationInfo: `applications/v1/UpdateAppFormEducationInfo`,
  deleteAppFormDocument: `applications/v1/DeleteAppFormDocument`,
  addAppFormDocument: `applications/v1/AddAppFormDocument`,
  processApplication: `applications/v1/ProcessApplication`,
  createServiceRequest: `Services/v1/CreateServiceRequest`,
  getServiceRequests: `Services/v1/GetServiceRequests`,
  deleteServiceRequest: `Services/v1/DeleteServiceRequest`,
  deleteServiceRequestDocument: `Services/v1/DeleteServiceRequestDocument`,
  updateServiceRequestStatus: `Services/v1/UpdateServiceRequestStatus`,
  sendServiceRequest: `Services/v1/SendServiceRequest`,
  getServiceRequestDetails: `Services/v1/GetServiceRequestDetails`,
  postServiceRequestComments: `Services/v1/PostServiceRequestComments`,
  getServiceRequestComments: `Services/v1/GetServiceRequestComments`,
  deleteServiceRequestComment: `Services/v1/DeleteServiceRequestComment`,
  deleteSentServiceRequest: `Services/v1/DeleteSentServiceRequest`,
  getReceivedServiceRequests: `Services/v1/GetReceivedServiceRequests`,
  updateServiceRequestComment: `Services/v1/UpdateServiceRequestComment`,
  getSecurityPin: `Users/v1/GetSecurityPin`,
  createSecurityPin: `Users/v1/CreateSecurityPin`,
  removeSecurityPin: `Users/v1/DeleteSecurityPin`,
  getAccountTransactionsSummary: `Reports/v1/GetAccountTransactionsSummary`,
  getAccountInvoicesTransactions: `Reports/v1/GetAccountInvoicesTransactions`,
  getInvoiceTransactions: `Reports/v1/GetInvoiceTransactions`,
  getAssetsTransactionSummary: `Reports/v1/GetAssetsTransactionSummary`,
  getAssetTransactions: `Reports/v1/GetAssetTransactions`,
};
/*Api Urls*/
